var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { routeToPage, redirectToPage } from '../../redux/pathInfo';
import { logoutRegistrant } from '../../redux/registrantLogin/actions';
import { openStartNewRegistrationDialogDuringRegistration } from '../../dialogs';
import * as currentRegistrant from '../../redux/selectors/currentRegistrant';
import { DECLINE, GUEST_REGISTRATION, REGISTRATION } from '../../redux/website/registrationProcesses';
/**
 * @param props.config.text Registration dialog text
 * @param props.style Styling for registration dialog
 * @param props.classes Classnames for registration dialog
 * Based on user state and current page
 * Dispatch actions either to redirect to registration start,
 * logout and redirect to 'register' page, or prompt with new registration dialog.
 * RegisterNow widget can exist in each of the conditions, all actions are available
 * RegisterAnother widget can only exists on post-reg pages,
 * openStartNewRegistrationDialog is the only available action
 */
export var promptToStartNewRegistration = function (props) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, Promise, function () {
        var state, loggedIn, registrationPage, registrationDeclinePage, titleText;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    loggedIn = currentRegistrant.isLoggedIn(state);
                    registrationPage = REGISTRATION.isTypeOfCurrentPage(state) || GUEST_REGISTRATION.isTypeOfCurrentPage(state);
                    registrationDeclinePage = DECLINE.isTypeOfCurrentPage(state);
                    titleText = props.config.text.htmlContent
                        ? props.config.text.htmlContent.replace(/<[^>]*>/g, '')
                        : props.config.text;
                    if (!loggedIn && !registrationPage && !registrationDeclinePage) {
                        return [2 /*return*/, dispatch(routeToPage('register'))];
                    }
                    if (!registrationDeclinePage) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(logoutRegistrant())];
                case 1:
                    _a.sent();
                    return [2 /*return*/, dispatch(redirectToPage('register'))];
                case 2: return [2 /*return*/, dispatch(openStartNewRegistrationDialogDuringRegistration({
                        title: titleText,
                        classes: __assign({}, props.classes),
                        style: props.style,
                        startWithDefaultRegPath: props.startWithDefaultRegPath || false
                    }))];
            }
        });
    }); };
};
